<!-- Close Button -->
<button class="close-icon" tabindex="-1" type="button" mat-dialog-close mat-icon-button>
  <mat-icon>close</mat-icon>
</button>

<!-- Title -->
<h5 cdkFocusInitial tabindex="-1" mat-dialog-title>{{ header }}</h5>

<mat-dialog-content>
  <form class="dialog-form" [formGroup]="defectForm" (ngSubmit)="onSubmit()">
    <div class="input-section">
      <!-- Tipologia Difetto -->
      <mat-form-field appearance="fill" class="width-100">
        <mat-label>{{
          "new_defect_dialog.tipologia_difetto" | translate
          }}</mat-label>
        <mat-select formControlName="tipologiaDifetto" (selectionChange)="onSelectTipologiaDifetto()">
          <mat-option [value]="elemento" *ngFor="let elemento of elementoList">
            {{ elemento }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Codice difetto - Descrizione difetto -->
      <mat-form-field appearance="fill" class="width-100">
        <mat-label>{{
          "new_defect_dialog.codice_descrizione_difetto" | translate
          }}</mat-label>
        <input type="text" matInput formControlName="codice_descrizione_difetto"
          [readonly]="defectForm.get(['tipologiaDifetto'])?.value == null" />
      </mat-form-field>
    </div>

    <!-- Defect List -->
    <div class="defect-section">
      <ng-container *ngIf="defectList.length != 0; else noMaterialSelected">
        <mat-action-list *ngIf="filteredDefectList.length != 0; else noDataFound">
          <a mat-list-item class="list-defects" (click)="onClickDefect(defect)"
            *ngFor="let defect of filteredDefectList">
            {{
            defect["Codice difetto"] + " - " + defect["Descrizione difetto"]
            }}
          </a>
        </mat-action-list>

        <ng-template #noDataFound>
          <h4>{{ "new_defect_dialog.no_defects_found" | translate }}</h4>
        </ng-template>
      </ng-container>

      <ng-template #noMaterialSelected>
        <h4>
          {{ "new_defect_dialog.select_material_to_view_defects" | translate }}
        </h4>
      </ng-template>
    </div>

    <!-- Codice difetto -->
    <div class="input-section">
      <mat-form-field appearance="fill" class="width-100">
        <mat-label>{{
          "new_defect_dialog.codice_difetto" | translate
          }}</mat-label>
        <input type="text" matInput formControlName="codice_difetto" readonly />
      </mat-form-field>

      <!-- Descrizione difetto -->
      <mat-form-field appearance="fill" class="width-100">
        <mat-label>{{
          "new_defect_dialog.descrizione_difetto" | translate
          }}</mat-label>
        <input type="text" matInput formControlName="descrizione_difetto" readonly />
      </mat-form-field>
    </div>

    <!-- G -->
    <div>
      <mat-form-field appearance="fill" class="width-100">
        <mat-label>{{ "new_defect_dialog.g_value" | translate }}</mat-label>
        <mat-select formControlName="G">
          <mat-option [value]="gValue" *ngFor="let gValue of gValueOptions">
            {{ gValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Estensione K1 -->
    <div class="input-section">
      <div class="check-box">
        <div class="field-title">{{ "new_defect_dialog.estensione_k1" | translate }}</div>
        <mat-checkbox formControlName="k1_1"> 0.2 </mat-checkbox>
        <mat-checkbox formControlName="k1_2"> 0.5 </mat-checkbox>
        <mat-checkbox formControlName="k1_3"> 1 </mat-checkbox>
      </div>

      <!-- Intensità K2 -->
      <div class="check-box">
        <div class="field-title">{{ "new_defect_dialog.intensita_k2" | translate }}</div>
        <mat-checkbox formControlName="k2_1"> 0.2 </mat-checkbox>
        <mat-checkbox formControlName="k2_2"> 0.5 </mat-checkbox>
        <mat-checkbox formControlName="k2_3"> 1 </mat-checkbox>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <!-- Delete -->
      <button
        type="button"
        mat-flat-button
        color="warn"
        (click)="onClickDelete()"
        *ngIf="defectType == bridgeConstants.defectDialog.editDefect"
      >
        {{ "common.buttons.delete" | translate }}
      </button>

      <!-- Submit -->
      <button type="submit" mat-flat-button color="primary" [disabled]="!defectForm.valid">
        {{ "common.buttons.submit" | translate }}
      </button>
    </div>
  </form>
</mat-dialog-content>
